
import { BlogPost } from "@/types/blog";
import { content } from "./content";
import musikCoachingHero from "@/assets/blog/musik-coaching-hero.webp";

export const MusikUndEmotionen: BlogPost = {
  title: "Musik & Coaching – Dein persönlicher Soundtrack für klare Entscheidungen",
  metaTitle: "Musik & Coaching: Soundtrack für Entscheidungen",
  excerpt: "Wie Musik dein Gehirn in Sekundenbruchteilen verändert und Klarheit für deine Entscheidungen schafft.",
  date: "04.03.2025",
  lastUpdated: "13.10.2025",
  slug: "musik-und-emotionen",
  imageUrl: musikCoachingHero,
  category: "Finanzpsychologie",
  tags: ["Musik", "Emotionen", "Entscheidungsfindung", "Neuroplastizität", "Coaching"],
  author: "Jörg Hörmann",
  authorTitle: "Finanz- & Executive Coach",
  content
};
